/**
 * The Workshop's game tables (/api/v1/workshop/games/<id>/tables), one
 * request per game at a time — the shape the ported screens expect from
 * the Lab's tablesCache, read from the Workshop API.
 */
import { api } from '../../lib/api'
import { gameIdFor } from './workshopApi'

const last = new Map<string, unknown>()
const inflight = new Map<string, Promise<unknown>>()

function url(gameCode: string, orgId: number | string): string {
  return `/api/v1/workshop/games/${gameIdFor(orgId, gameCode)}/tables`
}

export function cachedTables<T>(gameCode: string, orgId: number | string): T | undefined {
  try {
    return last.get(url(gameCode, orgId)) as T | undefined
  } catch {
    return undefined
  }
}

export function fetchTables<T>(gameCode: string, orgId: number | string): Promise<T> {
  let key: string
  try {
    key = url(gameCode, orgId)
  } catch (e) {
    return Promise.reject(e)
  }
  let p = inflight.get(key) as Promise<T> | undefined
  if (!p) {
    const req = api<T>(key)
    p = req
    inflight.set(key, req)
    const done = () => { if (inflight.get(key) === req) inflight.delete(key) }
    req.then((d) => { last.set(key, d); done() }, done)
  }
  return p
}

export function resetTablesCache(): void {
  last.clear()
  inflight.clear()
}
